export const sortByLastModification = (data: any[]) => {
    if (!Array.isArray(data)) {
        console.error('sortByLastModification: Expected an array, received:', data);
        return [];
    }

    return [...data].sort((a, b) => {
        return new Date(b.lastModificationTime).getTime() - new Date(a.lastModificationTime).getTime();
    });
};